export default "__VITE_ASSET__BCs6urN5__"